import api from "@/api";
import { defineStore } from "pinia";
import { Product } from "@/interfaces/product.interface";

export const useProductStore = defineStore({
  id: "productStore",
  state: (): {
    loading: boolean;
    products: Product[]
  } => ({
    loading: false,
    products: [] as Product[],
  }),
  getters: {
    getProducts(state): Product[] {
      return state.products;
    },
  },
  actions: {
    async fetchProducts() {
      this.loading = true;
      try {
        const productsResponse = await api.get("/v2/organisation/products");

        if (productsResponse.status !== 200) {
          throw new Error("Failed to fetch subjects from API.");
        }

        const productsData = productsResponse.data.data;
        this.products = productsData;
      } catch (error: any) {
        console.log("Error: ", error);

        if (error.code) {
          throw new Error(error.message);
        }
      } finally {
        this.loading = false;
      }
    },
  },
  persist: true,
});
